import axios from '../../axios'

export const getSummaryDetails = async (accountId, aggregated = false, portal = 1) => {
    try {
        const url = aggregated ? `/api/v3/aggregate/analysis/customAnalysis?reportReferenceId=${accountId}&portal=${portal}`: `/api/v3/analysis/customAnalysis?accountId=${accountId}&portal=${portal}`;
        const resp = await axios.get(url);
        return resp.data;
    } catch (error) {
        throw error
    }
}

export const getOverview = async (accountId, aggregated = false) => {
    try {
        const url = aggregated ? `/api/v3/aggregate/analysis/summary?reportReferenceId=${accountId}` : `/api/v3/analysis/summary?accountId=${accountId}`;
        const resp = await axios.get(url);
        return resp.data;
    } catch (error) {
        throw error;
    }
}

export const getTransactionList = async (accountId = 16702, page = 1, pagesize = 10, orderBy = "asc", sortBy = "transaction_date") => {
    try {
        const resp = await axios.post(`/internal/api/file/transactions?accountId=${accountId}&indexRequired=null&page=${page}&size=${pagesize}&order=${orderBy}&sortBy=${sortBy}`, {})
        return resp.data;
    } catch (error) {
        throw error
    }
}

export const extractFileDetails = async (password = "", formData) => {
  try {
    const resp = await axios.post(
      `/api/bsa/v3/file/extractDetails?password=${password}`, formData,
    );
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const createReport = async (formData) => {
  try {
    const resp = await axios.post(`/internal/api/report/create`, formData);
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateReport = async (formData) => {
  try {
    const resp = await axios.post(`/internal/api/report/update`, formData);
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAnalysisProgress = async (reportId) => {
  try {
    const resp = await axios.get(`/api/bsa/v3/report?reportId=${reportId}`);
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getBankListOptions = async (isFiu = false) => {
  try {
    const resp = await axios.get(`/api/bsa/v2/bank?isFiu=${isFiu}`);
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getReportDetailByReferrenceId = async (reportId) => {
    try {
        const resp = await axios.get(`/api/bsa/v3/report?reportId=${reportId}`);
        return resp.data;
    } catch (error) {
        throw error;
    }
}